import { createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '@/components/shared/PageContainer';
import { queryClient } from '@/lib/utils/queryClient';
import { PlatformFeaturesTable } from '../-components/PlatformFeaturesTable';
import { adminPlatformFeaturesQueryOptions } from '../-hooks/useAdminPlatformFeatures';
import { usePlatformFeaturesPage } from '../-hooks/usePlatformFeaturesPage';

/**
 * No `validateSearch`: the endpoint takes no paging, sort or filter parameters,
 * so the table works on the full response client-side and keeps nothing in the
 * URL.
 */
export const Route = createFileRoute('/management/platform-features/(pages)/')({
  // The rejection is swallowed on purpose. The loader is a prefetch — its only
  // job is to have the list already warm when the component mounts. Letting it
  // reject hands the route to the router's error boundary, which replaces the
  // whole page; the table's own "Could not load platform features." banner then
  // never renders, and that banner is what stops a failed load from reading as
  // "this platform has no features". The component's `useQuery` hits the same
  // failure and surfaces it inline.
  loader: () =>
    queryClient
      .ensureQueryData(adminPlatformFeaturesQueryOptions())
      .catch(() => undefined),
  component: PlatformFeaturesPage,
});

function PlatformFeaturesPage() {
  const page = usePlatformFeaturesPage();

  return (
    <PageContainer>
      <PlatformFeaturesTable page={page} />
    </PageContainer>
  );
}
